/**
 * <s-tilt> — tilts its [data-tilt-target] toward the pointer by writing
 * --tilt-x / --tilt-y custom properties. Fine pointers only; does nothing when
 * the shopper prefers reduced motion.
 */
class STilt extends HTMLElement {
  #target = null;
  #frame = 0;

  connectedCallback() {
    const reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    const fine = window.matchMedia('(hover: hover) and (pointer: fine)').matches;
    this.#target = this.querySelector('[data-tilt-target]');
    if (reduced || !fine || !this.#target) return;
    this.addEventListener('pointermove', this.#onMove);
    this.addEventListener('pointerleave', this.#onLeave);
  }

  disconnectedCallback() {
    this.removeEventListener('pointermove', this.#onMove);
    this.removeEventListener('pointerleave', this.#onLeave);
    cancelAnimationFrame(this.#frame);
  }

  #onMove = (event) => {
    const rect = this.getBoundingClientRect();
    const x = (event.clientX - rect.left) / rect.width - 0.5;
    const y = (event.clientY - rect.top) / rect.height - 0.5;
    cancelAnimationFrame(this.#frame);
    this.#frame = requestAnimationFrame(() => {
      this.#target.style.setProperty('--tilt-y', `${(x * 14).toFixed(2)}deg`);
      this.#target.style.setProperty('--tilt-x', `${(-y * 8).toFixed(2)}deg`);
    });
  };

  #onLeave = () => {
    cancelAnimationFrame(this.#frame);
    this.#target.style.removeProperty('--tilt-y');
    this.#target.style.removeProperty('--tilt-x');
  };
}

if (!customElements.get('s-tilt')) customElements.define('s-tilt', STilt);
